export default {
  breach: 'breach',
  breach_plus: 'breachPlus',
  credit_expert: 'creditExpert',
  identity: 'identityPlus',
  basic: 'free',
};
